<template>
  <v-row>
    <v-col
      v-for="service in services"
      :key="service.id"
      cols="12"
      sm="6"
      md="4"
      lg="3"
      :class="{ 'service-col--five': services.length === 5 }"
    >
      <ServiceCard
        :title="service.title"
        :image="service.image"
        :link="service.link"
        :is-schedule-exist="service.isScheduleExist"
        :show-hint="service.showHint"
        :schedule-link="service.scheduleLink"
        :action-title="service.actionTitle"
        :badge="service.badge"
        :hint="service.hint"
      />
    </v-col>
  </v-row>
</template>

<script>
import store from '@/store'
import { computed } from '@vue/composition-api'
import ServiceCard from "./ServiceCard.vue"; // Adjust the path as necessary
import { LICENSE_PAYMENT_TEST_MODE } from '@/views/pages/licenses/testMode'

export default {
  components: {
    ServiceCard,
  },
  setup() {
    const baseServices = [
      {
        id: 1,
        title: "Билеты в музеи",
        image: "ticket.webp",
        link: "/new",

        // График у билетов убран по просьбе заказчика: одиночная и
        // множественная подача теперь обе внутри «Заказать». Подсказка
        // (вопросик) остаётся.
        isScheduleExist: false,
        showHint: true,
      },
      {
        id: 2,
        title: "Радио/Аудиогид",
        image: "rg.webp",
        link: "/new-rg-ag",
        isScheduleExist: false,
        scheduleLink: "",

        // Подсказка у вопросика (05.10.2026), как у других карточек.
        hint: "Здесь можно заказать технические средства ведения экскурсий",
      },
      {
        id: 3,
        title: "Транспорт",
        image: "van.webp",
        link: "/new-transport?tab=0",

        // «Подать график» отключён 05.10.2026 (просьба Глеба), код оставлен:
        // isScheduleExist: true,
        // scheduleLink: "/new-transport?tab=1",

        // Подсказку у вопросика оставляем, как была (Глеб, 05.10.2026).
        showHint: true,
      },
      {
        id: 4,
        title: "Гид",
        image: "guide.webp",
        link: "/new-guide?tab=0",

        // «Подать график» отключён 05.10.2026 (просьба Глеба), код оставлен:
        // isScheduleExist: true,
        // scheduleLink: "/new-guide?tab=1",

        // Подсказку у вопросика оставляем, как была (Глеб, 05.10.2026).
        showHint: true,
      },
    ]

    // Карточка лицензий гидов. С 03.10.2026 (правка Глеба) стоит первой —
    // выше «Билетов в музеи» — и видна только пока идёт приём заявок на
    // продление и обучение: признак приходит с /auth/me. Кнопка с 05.10.2026 —
    // «Заказать», как у остальных карточек. С 23.10.2026 (правка Глеба) она
    // ведёт в «Продление лицензий», а не сразу в «Оплату продления»: клиент
    // сначала добавляет лицензии и подаёт заявку, оплата — следующим шагом.
    const licensePayment = {
      id: 5,

      // Формулировка бухгалтерии (22.09.2026): для клиента это консультационные
      // услуги, лицензии — пояснение в скобках. Что внутри — подсказкой у
      // вопросика, как у билетов.
      title: "Консультационные услуги (лицензии)",
      hint: "Первичное получение, продление",
      image: "license.webp",
      link: "/prolongation",
      isScheduleExist: false,
      scheduleLink: "",

      // Пока раздел проверяют, на карточке висит «Тестовый режим», чтобы
      // клиенты не заходили (см. testMode.js).
      badge: LICENSE_PAYMENT_TEST_MODE ? "Тестовый режим" : "",
    }

    const services = computed(() => (
      store.state.app.licenseCardVisible ? [licensePayment, ...baseServices] : baseServices
    ))

    return { services }
  },
}
</script>

<style>
/* Пять карточек в один ряд помещаются только на широком экране: на ноутбуке
   двум кнопкам («Подать график» и «Заказать») в пятой части ширины тесно.
   Поэтому до 1700px сетка прежняя, и пятая карточка уходит на вторую строку. */
@media (min-width: 1700px) {
  .service-col--five {
    flex: 0 0 20%;
    max-width: 20%;
  }
}
</style>
